import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { WorkflowDetail, WorkflowPayload } from "../declarations/interface";
import flowService from "../services/flowService";

export const getWorkflowById: any = createAsyncThunk('workflow/getWorkflowById', async (id: string) => {
  return flowService.getWorkflowById(id)
});

export const createWorkflow: any = createAsyncThunk('workflow/createWorkflow', async (workflow: WorkflowPayload) => {
  return flowService.createWorkflow(workflow)
});

export const updateWorkflow: any = createAsyncThunk('workflow/updateWorkflow', async (workflow: WorkflowPayload) => {
  return flowService.updateWorkflow(workflow)
});

export const updateWorkflowName: any = createAsyncThunk('workflow/updateWorkflowName', async ({ id, name }: { id: string; name: string }) => {
  return flowService.updateWorkflowName(id, name)
});

const DEFAULT: {
  workflow?: WorkflowDetail;
  status: {
    type: 'SUCCESS' | 'FAILURE' | 'ERROR';
    message: string;
  } | null;
} = {
  status: null,
}

const slice = createSlice({
  name: "workflow",
  initialState: DEFAULT,
  reducers: {
    clearStatus(state) {
      state.status = null;
    }
  },
  extraReducers: {
    [getWorkflowById.fulfilled]: (state, action) => {
      state.workflow = action.payload;
    },
    [getWorkflowById.rejected]: state => {
      state.status = {
        type: 'FAILURE',
        message: 'Error while fetching workflow details'
      }
    },
    [createWorkflow.fulfilled]: (state, action) => {
      state.workflow = action.payload;
      state.status = {
        type: 'SUCCESS',
        message: 'Workflow created successfully'
      }
    },
    [createWorkflow.rejected]: state => {
      state.status = {
        type: 'FAILURE',
        message: 'Error while creating workflow'
      }
    },
    [updateWorkflow.fulfilled]: (state, action) => {
      state.workflow = action.payload;
      state.status = {
        type: 'SUCCESS',
        message: 'Workflow updated successfully'
      }
    },
    [updateWorkflow.rejected]: state => {
      state.status = {
        type: 'FAILURE',
        message: 'Error while updating workflow'
      }
    },
    [updateWorkflowName.fulfilled]: (state) => {
      state.status = {
        type: 'SUCCESS',
        message: 'Workflow name updated successfully'
      }
    },
    [updateWorkflowName.rejected]: state => {
      state.status = {
        type: 'FAILURE',
        message: 'Error while updating workflow name'
      }
    }
  },
});

export const reducer = slice.reducer;
export const actions = slice.actions;

export default slice;
